export enum NotificationTypeEnum {
  System = 'system',
  CollaboratorCellTag = 'collaboratorCellTag',
  CollaboratorMultiRowTag = 'collaboratorMultiRowTag',
}

export enum NotificationStatesEnum {
  Unread = 'unread',
  Read = 'read',
}
